import { render, staticRenderFns } from "./AnnouncementsPage.vue?vue&type=template&id=93344918&scoped=true"
import script from "./AnnouncementsPage.vue?vue&type=script&lang=js"
export * from "./AnnouncementsPage.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementsPage.vue?vue&type=style&index=0&id=93344918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93344918",
  null
  
)

export default component.exports